<template>
<div class="surveillance-datasets-modal">
  <modal v-model="datasetsModal"
         :footer="false"
         size="lg"
         :title="`${surveillance.establishment.name} - SPIADI${surveillance.year}`">
    <div v-if="datasetsModal"
         class="datasets-modal">
      <div v-for="(c, k) in categories"
           :key="`${c.type}-category`">
        <hr v-if="k > 0"/>
        <h3>
          Jeux de données <span :class="`label label-${c.type}`">{{ c.label }}</span>
        </h3>
        <btn v-for="l in c.list" :key="`${c.type}-category-${l}`"
             :class="`btn btn-${c.type}`"
             size="sm"
             @click="editDataset(c.type, l)">
          <strong>{{l}}</strong>
        </btn>
      </div>
    </div>
    <div v-if="editModal">
      <div v-if="edit.module !== 'observa4'">
        <sui-dataset-modal
          append-to-body
          :name="edit.name"
          v-model="editModal"
          :module="edit.module"
          :surveillance="surveillance"></sui-dataset-modal>
      </div>
      <div v-else>
        <sui-observa4-dataset-modal
          append-to-body
          :name="edit.name"
          v-model="editModal"
          :module="edit.module"
          :surveillance="surveillance"></sui-observa4-dataset-modal>
      </div>
    </div>
  </modal>
</div>
</template>

<script>
import suiDatasetModal from '@/sui/components/datasetmodal'
import suiDatasetObserva4Modal from '@/sui/components/datasetobs4modal'
import modules from '@/sui/data/modules'

export default {
  name: 'surveillance-datasets-modal',

  props: {
    surveillance: Object,

    value: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      datasetsModal: this.value,
      editModal: false,
      edit: {
        name: '',
        module: ''
      }
    }
  },

  watch: {
    value: function (value) {
      this.datasetsModal = value
    },

    datasetsModal: {
      handler () {
        this.$emit('input', this.datasetsModal)
        if (!this.datasetsModal) {
          this.editModal = false
          this.edit.name = ''
          this.edit.module = ''
        }
      },
      deep: true
    }
  },

  computed: {
    categories: function () {
      if (this.surveillance == null) {
        return []
      }

      const result = []
      for (let p in this.surveillance.modules) {
        const m = this.surveillance.modules[p]
        if (m.dset == null || m.dset.length === 0) {
          continue
        }

        const list = []
        for (let j = 0; j !== m.dset.length; ++j) {
          list.push(m.dset[j].name)
        }

        result.push(
          {
            type: p,
            label: modules[this.surveillance.year][p].label,
            list: list
          }
        )
      }
      return result
    }
  },

  methods: {
    editDataset: function (m, n) {
      this.edit.name = n
      this.edit.module = m
      this.editModal = true
    }
  },

  components: {
    'sui-dataset-modal': suiDatasetModal,
    'sui-observa4-dataset-modal': suiDatasetObserva4Modal
  }
}
</script>

<style scoped lang="less">
.datasets-modal {
  .btn {
    margin-right: 0.5rem;
  }
}
</style>
